import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'document-info',
  templateUrl: '../sharedTemplates/document-info.component.html',
})
export class DocumentInfoComponent implements AfterViewInit {
  menuSelected = 0;
  constructor(private _router: Router, public _UiHelper: UiHelper) {}

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();
  }

  MenuSelect(menuId) {
    if (menuId == this.menuSelected) {
      this.menuSelected = 0;
    } else {
      this.menuSelected = menuId;
    }
  }

  UploadPage() {
    this._router.navigate(['/document']);
  }

  UploadPage2() {
    this._router.navigate(['/documentInfoUpload']);
  }
}
